<template>
  <div id="nav">
    <div v-show="amLoggedIn">
      <router-link to="/members" v-show="showMbrs">Members</router-link>
      |
      <router-link to="/trials">Trials</router-link>
      |
      <router-link to="/clubs">Host Clubs</router-link>
      |
      <router-link to="/officials">Officials</router-link>
      |
      <router-link to="/member">Member Detail</router-link>
      |
      <router-link to="/dogs" v-show="showDogs">Dogs</router-link>
      |
      <router-link to="/about">About</router-link>
      |
      <router-link to="/logout">Log Out</router-link>
      |
      <router-link to="/modpwd">Change password</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  computed: {
    showMbrs() {
      //return this.$store.state.loggedIn
      return this.$hasRole(['adm', 'sys'])
    },
    showDogs() {
      //return this.$store.state.loggedIn
      return this.$hasRole(['adm', 'sys'])
    },
    amLoggedIn() {
      try {
        if (this.$usrStore.token == null) {
          if (localStorage.getItem('token') !== 'undefined') {
            if (localStorage.getItem('token') !== 'null') {
              if (localStorage.getItem('token').length > 4) {
                this.$initFromToken(localStorage.getItem('token'))
              }
            }
          }
        }
        return (this.$usrStore.token != null)
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>
